<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img src="@/assets/logo.png" alt="Logo" class="login-logo" />
        <h2>光衍熔纤助手管理平台</h2>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginFormRef">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名">
            <template #prefix>
              <el-icon><User /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
          >
            <template #prefix>
              <el-icon><Lock /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-button" @click="handleLogin"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    
    <!-- 备案信息底部栏 -->
    <footer class="beian-footer">
      <div class="beian-content">
        <div class="beian-item">
          <img src="@/assets/guohui.png" alt="国徽" class="beian-icon">
          <span>粤公网安备44030502010225号</span>
        </div>
        <div class="beian-item">
          <span>粤ICP备2023077234号-4</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { User, Lock } from "@element-plus/icons-vue";
import { webAdminLogin } from "@/api/webadmin";

export default {
  name: "LoginPage",
  components: {
    User,
    Lock,
  },
  setup() {
    const router = useRouter();
    const loginFormRef = ref(null);
    const loginForm = reactive({
      username: "",
      password: "",
    });

    const rules = {
      username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      password: [{ required: true, message: "请输入密码", trigger: "blur" }],
    };

    const handleLogin = () => {
      loginFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            // 调用WebAdmin登录API
            const response = await webAdminLogin({
              username: loginForm.username,
              password: loginForm.password,
            });

            if (response && response.token) {
              // 保存token和用户信息
              localStorage.setItem("token", response.token);

              // 保存用户信息
              const userInfo = {
                username: response.username,
                name: response.name,
                role: response.role,
                avatar:
                  "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
              };
              localStorage.setItem("userInfo", JSON.stringify(userInfo));

              ElMessage.success("登录成功");
              router.push("/");
            } else {
              throw new Error("登录失败：服务器响应异常");
            }
          } catch (error) {
            console.error("登录失败:", error);
            ElMessage.error(error.response?.data?.message || "用户名或密码错误");
          }
        }
      });
    };


    return {
      loginForm,
      loginFormRef,
      rules,
      handleLogin,
    };
  },
};
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7f9;
}

.login-box {
  width: 400px;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.login-button {
  width: 100%;
}

/* 备案信息底部栏样式 */
.beian-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  background: transparent;
  border: none;
}

.beian-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
}

.beian-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.beian-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .beian-content {
    flex-direction: column;
    gap: 10px;
  }
  
  .beian-footer {
    padding: 10px 0;
    font-size: 11px;
  }
  
  .beian-icon {
    width: 16px;
    height: 16px;
  }
}
</style>
